<template>
    <v-card class="elevation-0">
      <v-row class="pa-0 ma-0">
        <v-col cols="6">
          <v-card class="mx-auto">
            <!-- <v-card-title> Register Your P-Spot </v-card-title> -->
  
            <v-img
              class="align-end text-white"
              height="200"
              src="/scheme-serial-numer.jpeg"
              contain
            />
  
            <!-- <v-card-subtitle class="pt-4"> Number 10 </v-card-subtitle> -->
  
            <v-card-text>
              <HelpFormInput
                v-model="serialNumber"
                label="Device Serial Number"
                placeholder="Enter device serial number"
                help-text="The serial number of the device."
                counter="20"
                persistent-counter
                :rules="rules.serialNumber"
                @update:model-value="
                  (v) =>
                    onUpdate({
                      ...modelValue,
                      serialNumber: v,
                    })
                "
              />
              <HelpFormInput
                v-model="name"
                label="Inventory Name"
                placeholder="Inventory Name"
                help-text="Give recognizable name to your Inventory Item."
                :rules="rules.name"
                @update:model-value="(v) => onUpdate({ ...modelValue, name: v })"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="mx-auto">
            <!-- <v-card-title> Device Specs </v-card-title> -->
            <v-img
              class="align-end text-white"
              height="200"
              src="/screen-specs.webp"
              contain
            />
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <HelpFormInput
                    v-model="width"
                    label="Width"
                    placeholder="Width"
                    help-text="The width of the device."
                    :rules="rules.width"
                  />
                </v-col>
                <v-col cols="6">
                  <HelpFormInput
                    v-model="height"
                    label="Height"
                    placeholder="Height"
                    help-text="The height of the device."
                    :rules="rules.height"
                    @update:model-value="
                      (v) => onUpdate({ ...modelValue, height: v })
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <HelpFormInput
                    v-model="resolutionX"
                    label="Resolution X (px)"
                    placeholder="Resolution X"
                    help-text="The resolution of the device in X direction."
                    :rules="rules.resolutionX"
                    @update:model-value="
                      (v) => onUpdate({ ...modelValue, resolutionX: v })
                    "
                  />
                </v-col>
                <v-col cols="6">
                  <HelpFormInput
                    v-model="resolutionY"
                    label="Resolution Y (px)"
                    placeholder="Resolution Y"
                    help-text="The resolution of the
                    device in Y direction."
                    :rules="rules.resolutionY"
                    @update:model-value="
                      (v) => onUpdate({ ...modelValue, resolutionY: v })
                    "
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </template>
  
  
  <script>
  import HelpFormInput from "../../atoms/common/inputs/HelpFormInput.vue";
  
  export default {
    components: {
      HelpFormInput,
    },
    props: {
      modelValue: {
        type: Object,
        default: () => ({
          name: null,
          serialNumber: null,
          width: 0,
          height: 0,
          resolutionX: 0,
          resolutionY: 0,
        }),
      },
    },
    emits: ["next", "update:modelValue"],
    data() {
      return {
        name: null,
        serialNumber: null,
        width: 0,
        height: 0,
        resolutionX: 0,
        resolutionY: 0,
  
        rules: {
          name: [
            (v) => !!v || "Name is required",
            (v) =>
              (v && v.length <= 50) || "Name must be less than 50 characters",
          ],
          serialNumber: [
            (v) => !!v || "Serial number is required",
            (v) =>
              (v && v.length <= 20) ||
              "Serial number must be less than 20 characters",
            // srial number example": "1234567890ABCDEF"
            (v) =>
              /^[a-zA-Z0-9]+$/.test(v) || "Serial number must be alphanumeric",
          ],
          width: [
            (v) => !!v || "Width is required",
            (v) => (v && v > 0) || "Width must be greater than 0",
          ],
          height: [
            (v) => !!v || "Height is required",
            (v) => (v && v > 0) || "Height must be greater than 0",
          ],
          resolutionX: [
            (v) => !!v || "Resolution X is required",
            (v) => (v && v > 0) || "Resolution X must be greater than 0",
          ],
          resolutionY: [
            (v) => !!v || "Resolution Y is required",
            (v) => (v && v > 0) || "Resolution Y must be greater than 0",
          ],
        },
      };
    },
    computed: {},
  
    created() {},
    methods: {
      onUpdate(value) {
        this.$emit("update:modelValue", value);
      },
    },
  };
  </script>